/**
 * Domain type aliases for the action-plans slice, sourced from the generated
 * OpenAPI schema so they track the DRF serializers exactly (regenerate with
 * `npm run generate:api`). Components live under /api/v1/action-plans/.
 */
import type { components } from "@/lib/api/schema.gen";

type Schemas = components["schemas"];

export type ActionPlanListItem = Schemas["ActionPlanList"];
export type ActionPlanDetail = Schemas["ActionPlanDetail"];
export type ActionPlanCreate = Schemas["ActionPlanCreate"];
// The plan hierarchy is derived live on the server (no frozen thematic/issue/
// goal tables), so the tree nodes come from the hierarchy node schemas.
export type ActionPlanThematic = Schemas["HierarchyThematicNode"];
export type ActionPlanIssue = Schemas["HierarchyIssueNode"];
export type ActionPlanGoal = Schemas["HierarchyGoalNode"];
export type ActionPlanAction = Schemas["ActionPlanAction"];
// The goal CRUD endpoint (create/reword an objective) returns the catalogue
// Goal without the tree's nested actions.
export type ActionPlanGoalResponse = Schemas["ActionPlanGoal"];
export type ActionStatus = Schemas["ActionPlanActionStatusEnum"];
export type StakeholderGroup = Schemas["StakeholderGroup"];
export type ActionPlanConsultation = Schemas["ActionPlanConsultation"];

/** Writable subset of an action (the read-only server fields are stripped). */
export type ActionPatch = Schemas["PatchedActionPlanAction"];

/** The three action statuses, in the order the questionnaire presents them. */
export const ACTION_STATUSES: readonly ActionStatus[] = [
  "not_done",
  "in_progress",
  "done",
] as const;

// --- Prioritization endpoint (GET /action-plans/{id}/prioritization/) --------
// This custom action returns computed aggregates that aren't a model serializer,
// so the shape is declared here rather than sourced from the generated schema.

export interface PrioritizationGroup {
  id: string;
  consultation_id: string;
  name: string;
  is_open: boolean;
  share_token: string;
  response_count: number;
}

export interface PrioritizationComment {
  stakeholder_group__name: string;
  comment: string;
}

export interface PrioritizationActionScore {
  action_id: string;
  score: number;
  group_scores: { group_id: string; score: number }[];
  pre_prio: number | null;
  has_consultation: boolean;
  comment_count: number;
  comments: PrioritizationComment[];
}

export interface PrioritizationData {
  groups: PrioritizationGroup[];
  actions: PrioritizationActionScore[];
}
